import { render, staticRenderFns } from "./ImportImage.vue?vue&type=template&id=4a678df5&scoped=true"
import script from "./ImportImage.vue?vue&type=script&lang=js"
export * from "./ImportImage.vue?vue&type=script&lang=js"
import style0 from "./ImportImage.vue?vue&type=style&index=0&id=4a678df5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a678df5",
  null
  
)

export default component.exports